import { createAction } from '@reduxjs/toolkit';

export const authUserWithCode = createAction('AUTH_USER_WITHCODE', (code) => {
    return{
        payload: {
			code
        }
    }
});

export const authUserWithCodeSuccess = createAction('AUTH_USER_WITHCODE_SUCCESS', (code) => {
    return{
        payload: {
			code
        }
    }
});


export const authUserWithCodeFailure = createAction('AUTH_USER_WITHCODE_FAILURE', (code) => {
    return{
        payload: {
			code
        }
    }
});

export const merchantGetOrganization = createAction('MERCHANT_GET_ORGANIZATION', data => {
    return{
        payload: {
			data
        }
    }
});

export const merchantGetOrganizationSuccess = createAction('MERCHANT_GET_ORGANIZATION_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});

export const merchantGetOrganizationFailure = createAction('MERCHANT_GET_ORGANIZATION_FAILURE', data => {
    return{
        payload: {
			data
        }
    }
});


export const merchantGetBrandList = createAction('MERCHANT_GET_ORGANIZATION_LIST', data => {
    return{
        payload: {
			data
        }
    }
});

export const merchantGetBrandListSuccess = createAction('MERCHANT_GET_ORGANIZATION_LIST_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});

export const merchantGetBrandListFailure = createAction('MERCHANT_GET_ORGANIZATION_LIST_FAILURE', data => {
    return{
        payload: {
			data
        }
    }
});


export const merchantGetOrganizationBrands = createAction('MERCHANT_GET_ORGANIZATION_BRANDS', data => {
    return{
        payload: {
			data
        }
    }
});

export const merchantGetOrganizationBrandsSuccess = createAction('MERCHANT_GET_ORGANIZATION_BRANDS_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});

export const merchantGetOrganizationBrandsFailure = createAction('MERCHANT_GET_ORGANIZATION_BRANDS_FAILURE', data => {
    return{
        payload: {
			data
        }
    }
});

export const merchantGetOrganizationBrandDetails = createAction('MERCHANT_GET_ORGANIZATION_BRANDS_DETAILS', data => {
    return{
        payload: {
			data
        }
    }
});

export const merchantGetStoreListFromBrand = createAction('MERCHANT_GET_STORES_LIST_FROM_BRANDS', data => {
    return{
        payload: {
			data
        }
    }
});

export const merchantGetStoreListFromBrandSuccess = createAction('MERCHANT_GET_STORES_LIST_FROM_BRANDS_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});

export const merchantGetStoreListFromBrandFailure = createAction('MERCHANT_GET_STORES_LIST_FROM_BRANDS_FAILURE', data => {
    return{
        payload: {
			data
        }
    }
});


export const merchantGetStoreCountFromBrand = createAction('MERCHANT_GET_STORES_COUNT_FROM_BRANDS', data => {
    return{
        payload: {
			data
        }
    }
});

export const merchantGetStoreCountFromBrandSuccess = createAction('MERCHANT_GET_STORES_COUNT_FROM_BRANDS_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});

export const merchantGetStoreCountFromBrandFailure = createAction('MERCHANT_GET_STORES_COUNT_FROM_BRANDS_FAILURE', data => {
    return{
        payload: {
			data
        }
    }
});


export const merchantGetStoresDetailsOfBrand = createAction('MERCHANT_GET_STORES_DETAILS_OF_BRAND', data => {
    return{
        payload: {
			data
        }
    }
});


export const merchantGetStoresDetailsOfBrandSuccess = createAction('MERCHANT_GET_STORES_DETAILS_OF_BRAND_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});


export const merchantGetStoresDetailsOfBrandFailure = createAction('MERCHANT_GET_STORES_DETAILS_OF_BRAND_FAILURE', data => {
    return{
        payload: {
			data
        }
    }
});

export const updateAppOrgName = createAction('UPDATE_APP_ORG_NAME', data => {
    return{
        payload: {
			data
        }
    }
});

export const setReadAccessToken = createAction('SET_READ_ACCESS_TOKEN', data => {
    return{
        payload: {
			data
        }
    }
});


export const setIntegrationAccessToken = createAction('SET_INTEGRATION_ACCESS_TOKEN', data => {
    return{
        payload: {
			data
        }
    }
});


export const setInitialRoute = createAction('SET_INITIAL_ROUTE', data => {
    return{
        payload: {
			data
        }
    }
});


export const getStoreConnection = createAction('GET_STORE_CONNECTION', data => {
    return{
        payload: {
			data
        }
    }
});


export const getStoreConnectionSuccess = createAction('GET_STORE_CONNECTION_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});


export const getStoreConnectionFailure = createAction('GET_STORE_CONNECTION_FAILURE', data => {
    return{
        payload: {
			data
        }
    }
});



export const postStoreConnection = createAction('POST_STORE_CONNECTION', data => {
    return{
        payload: {
			data
        }
    }
});


export const postStoreConnectionSuccess = createAction('POST_STORE_CONNECTION_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});


export const postStoreConnectionFailure = createAction('POST_STORE_CONNECTION_FAILURE', data => {
    return{
        payload: {
			data
        }
    }
});


export const deleteStoreConnection = createAction('DELETE_STORE_CONNECTION', data => {
    return{
        payload: {
			data
        }
    }
});


export const deleteStoreConnectionSuccess = createAction('DELETE_STORE_CONNECTION_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});


export const deleteStoreConnectionFailure = createAction('DELETE_STORE_CONNECTION_FAILURE', data => {
    return{
        payload: {
			data
        }
    }
});

export const getAppAccessToken = createAction('GET_APP_ACCESS_TOKEN', data => {
    return{
        payload: {
			data
        }
    }
});


export const getAppAccessTokenSuccess = createAction('GET_APP_ACCESS_TOKEN_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});


export const getAppAccessTokenFailure = createAction('GET_APP_ACCESS_TOKEN_FAILURE', data => {
    return{
        payload: {
			data
        }
    }
});

export const updateMixPanel = createAction('UPDATE_MIX_PANEL', data =>{
    return {
        payload: {
            data
        }
    }
})

export const updateLoadingStatus = createAction('UPDATE_LOADING_STATUS', data => {
    return {
        payload: {
            data
        }
    }
})